// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-arrow-left.show-team__icon-back{
    color: var(--black-color);
    font-size: var(--space-and-half);
    margin-right: calc(var(--space) + var(--space-quarter));
    cursor: pointer;
}

.show-team__team-photo{
    margin-right: var(--space);
}

.show-team__team-photo .icon-ball {
    font-size: calc(var(--space-x3) + var(--space-half) + var(--space-eighth));
    color: var( --white-color );
    border-radius: 50%;
    padding: var( --space-quarter );
}

.show-team__team-photo img{
    width: calc(var(--space-x3) + var(--space-half));
    height: calc(var(--space-x3) + var(--space-half));
    border-radius: 50%;
}

.show-team__icon-edit {
    cursor: pointer;
    width: calc( var( --space ) + var( --space-eighth ) );
    height: calc( var( --space ) + var( --space-eighth ) );
}

.show-team__icon-edit path {
    fill: var( --black-color );
}

.league-show-team__title {
    background: var(--white-color);
    display: flex;
    align-items: center;
    /* margin: 0 0 var( --space-and-half ) 0; */
    padding: 24px 26px;
    border: 1px solid var(--new-gray-background-color);
}

.league-show-team__title .baloa-headline-2 {
    color: var(  --primary-very-dark-color );
}

.league-show-team__container {
    margin: 0 var( --space-and-half );
}

.league-show-team__container button.MuiTab-fullWidth {
    flex-grow: 0.2;
}

.league-show-team__container .new-tournament__center__content__tabs .MuiTabs-flexContainer {
    border-top: transparent;
}

.league-show-team__center__header {
    background-color: var(--white-color);
    padding: 0 calc( var( --space ) + var( --space-eighth ) );
    display: flex;
    justify-content: space-between;
    border-radius: var( --space-half );
}

.league-show-team__center__header__container {
    display: flex;
    align-items: center;
}

.league-show-team__gender-category {
    display: flex;
    align-items: center;
}

.show-team__team-data .baloa-headline-2 {
    color: var( --primary-very-dark-color );
}

.show-team__team-data__label.baloa-table,
.league-show-team__gender-category.baloa-table {
    color: var( --primary-dark-color );
}

.show-team__team-data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.league-show-team__padding__white{
    border-radius: 8px 8px 0px 0px;
    background-color: var(--white-color);
    padding: calc( var( --space ) + var( --space-eighth ) );
    margin-top:  var( --space );
}

.show-team__center__content {
    background-color: var( --white-color );
}

.tabpanel-line .table-component__table-container {
    padding: 0 var( --space );
}

.tabpanel-line .component-table-header__form__actions_grid-container {
    margin: 0 var( --space );
}

.show-team__team-code {
    display: flex;
    align-items: center;
    font-family: var(--secondary-font);
    font-size: var(--space);
}

.show-team__team-actions{
    display: flex;
    float: right;
    height: 0px;
}

.icon-copy-86{
    font-size: var(--space-and-half);
}

.show-team__header__button-options{
    display: flex;
    align-items: flex-end;
    position: relative;
    margin-left: var(--space);
    cursor: pointer;
    align-items: center;
}

.show-team__header__button-options span{
    font-weight: var(--font-bold);
}

.show-team__header__button-options__box{
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    width: 300px;
    right: 0;
    top: 50px;
    /* margin-right: calc( var(--space) + var(--space-quarter) ); */
    display: none;   
    border-radius: var(--space-half); 
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space-half);
}

.show-team__header__button-options__box.active{
    display: block;
    z-index: 1;
}

.show-team__header__button-options__box__box-option {
    cursor: pointer;
    border-radius: 8px;
    padding: var(--space-half);
}
.show-team__header__button-options__box__box-option:hover {
    background-color: var(--new-background-color);
}

.show-team__header__button-options__box__box-option .baloa-names {
    color: var(--primary-very-dark-color);
}

.show-team__header__button-options__box__box-option .baloa-username {
    color: var(--primary-dark-color);
}

.show-team__header__button-options__button.small {
    padding: 8px 12px;
}

.show-team__header__button-options__button .hubicon-person_add{
    grid-area: icon;
    font-size: 25px;
    color: var(--new-green-color);
    margin-right: 8px;
}

.show-team__header__button-options__button:hover .hubicon-person_add, .show-team__header__button-options__button:focus .hubicon-person_add{
    color: var(--white-color);
}

.show-team__team-options {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc( var(--space-x3) + var(--space-quarter) );
    border-radius: var( --space-half );
    background-color: var( --white-color );
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    padding: 0 var( --space-half-quarter );
    cursor: pointer;
    position: absolute;
    top: 35px;
    right: 20px;
}

.show-team__team-options .baloa-table-column {
    color: var( --primary-very-dark-color );
    white-space: nowrap;
    margin-left: var( --space-half );
}

.show-team__team-options .hubicon-edit::before {
    color: var(--primary-very-dark-color);
    font-size: 20px;
}

.show-team__header__button-options .icon-options{
    font-size: 20px;
    margin-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-show-team/LeagueShowTeamComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,uDAAuD;IACvD,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0EAA0E;IAC1E,2BAA2B;IAC3B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,gDAAgD;IAChD,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qDAAqD;IACrD,sDAAsD;AAC1D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,yDAAyD;IACzD,aAAa;IACb,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,uDAAuD;IACvD,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,+DAA+D;IAC/D,aAAa;IACb,gCAAgC;IAChC,kDAAkD;IAClD,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sDAAsD;IACtD,kCAAkC;IAClC,sCAAsC;IACtC,iDAAiD;IACjD,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".icon-arrow-left.show-team__icon-back{\n    color: var(--black-color);\n    font-size: var(--space-and-half);\n    margin-right: calc(var(--space) + var(--space-quarter));\n    cursor: pointer;\n}\n\n.show-team__team-photo{\n    margin-right: var(--space);\n}\n\n.show-team__team-photo .icon-ball {\n    font-size: calc(var(--space-x3) + var(--space-half) + var(--space-eighth));\n    color: var( --white-color );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n}\n\n.show-team__team-photo img{\n    width: calc(var(--space-x3) + var(--space-half));\n    height: calc(var(--space-x3) + var(--space-half));\n    border-radius: 50%;\n}\n\n.show-team__icon-edit {\n    cursor: pointer;\n    width: calc( var( --space ) + var( --space-eighth ) );\n    height: calc( var( --space ) + var( --space-eighth ) );\n}\n\n.show-team__icon-edit path {\n    fill: var( --black-color );\n}\n\n.league-show-team__title {\n    background: var(--white-color);\n    display: flex;\n    align-items: center;\n    /* margin: 0 0 var( --space-and-half ) 0; */\n    padding: 24px 26px;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.league-show-team__title .baloa-headline-2 {\n    color: var(  --primary-very-dark-color );\n}\n\n.league-show-team__container {\n    margin: 0 var( --space-and-half );\n}\n\n.league-show-team__container button.MuiTab-fullWidth {\n    flex-grow: 0.2;\n}\n\n.league-show-team__container .new-tournament__center__content__tabs .MuiTabs-flexContainer {\n    border-top: transparent;\n}\n\n.league-show-team__center__header {\n    background-color: var(--white-color);\n    padding: 0 calc( var( --space ) + var( --space-eighth ) );\n    display: flex;\n    justify-content: space-between;\n    border-radius: var( --space-half );\n}\n\n.league-show-team__center__header__container {\n    display: flex;\n    align-items: center;\n}\n\n.league-show-team__gender-category {\n    display: flex;\n    align-items: center;\n}\n\n.show-team__team-data .baloa-headline-2 {\n    color: var( --primary-very-dark-color );\n}\n\n.show-team__team-data__label.baloa-table,\n.league-show-team__gender-category.baloa-table {\n    color: var( --primary-dark-color );\n}\n\n.show-team__team-data {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.league-show-team__padding__white{\n    border-radius: 8px 8px 0px 0px;\n    background-color: var(--white-color);\n    padding: calc( var( --space ) + var( --space-eighth ) );\n    margin-top:  var( --space );\n}\n\n.show-team__center__content {\n    background-color: var( --white-color );\n}\n\n.tabpanel-line .table-component__table-container {\n    padding: 0 var( --space );\n}\n\n.tabpanel-line .component-table-header__form__actions_grid-container {\n    margin: 0 var( --space );\n}\n\n.show-team__team-code {\n    display: flex;\n    align-items: center;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n}\n\n.show-team__team-actions{\n    display: flex;\n    float: right;\n    height: 0px;\n}\n\n.icon-copy-86{\n    font-size: var(--space-and-half);\n}\n\n.show-team__header__button-options{\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    margin-left: var(--space);\n    cursor: pointer;\n    align-items: center;\n}\n\n.show-team__header__button-options span{\n    font-weight: var(--font-bold);\n}\n\n.show-team__header__button-options__box{\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    width: 300px;\n    right: 0;\n    top: 50px;\n    /* margin-right: calc( var(--space) + var(--space-quarter) ); */\n    display: none;   \n    border-radius: var(--space-half); \n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space-half);\n}\n\n.show-team__header__button-options__box.active{\n    display: block;\n    z-index: 1;\n}\n\n.show-team__header__button-options__box__box-option {\n    cursor: pointer;\n    border-radius: 8px;\n    padding: var(--space-half);\n}\n.show-team__header__button-options__box__box-option:hover {\n    background-color: var(--new-background-color);\n}\n\n.show-team__header__button-options__box__box-option .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.show-team__header__button-options__box__box-option .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.show-team__header__button-options__button.small {\n    padding: 8px 12px;\n}\n\n.show-team__header__button-options__button .hubicon-person_add{\n    grid-area: icon;\n    font-size: 25px;\n    color: var(--new-green-color);\n    margin-right: 8px;\n}\n\n.show-team__header__button-options__button:hover .hubicon-person_add, .show-team__header__button-options__button:focus .hubicon-person_add{\n    color: var(--white-color);\n}\n\n.show-team__team-options {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: calc( var(--space-x3) + var(--space-quarter) );\n    border-radius: var( --space-half );\n    background-color: var( --white-color );\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    padding: 0 var( --space-half-quarter );\n    cursor: pointer;\n    position: absolute;\n    top: 35px;\n    right: 20px;\n}\n\n.show-team__team-options .baloa-table-column {\n    color: var( --primary-very-dark-color );\n    white-space: nowrap;\n    margin-left: var( --space-half );\n}\n\n.show-team__team-options .hubicon-edit::before {\n    color: var(--primary-very-dark-color);\n    font-size: 20px;\n}\n\n.show-team__header__button-options .icon-options{\n    font-size: 20px;\n    margin-left: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
